import { useQueries } from '@tanstack/react-query';

import { fetchListOneApi } from '../api';

import { ListOneParams } from '../ListOne.types';

// The slices the status tabs offer, keyed by the ticketStatus they filter on.
export const LIST_ONE_STATUS_TABS = ['All', 'open-pending', 'open-error'];

/*
 * How many tickets each status tab holds under the other filters in force.
 * Asks for a single row per tab and reads the total, so it costs three small
 * requests rather than a dedicated endpoint.
 */
export default function useListOneStatusCountsQuery(params: ListOneParams) {
  const { page, first, rows, ticketStatus, ...filters } = params;

  const queries = useQueries({
    queries: LIST_ONE_STATUS_TABS.map((status) => ({
      queryKey: ['list', 'one', 'count', status, filters],
      queryFn: () =>
        fetchListOneApi({
          ...filters,
          ticketStatus: status,
          page: '1',
          rows: '1',
        }),
    })),
  });

  const counts: Record<string, number | undefined> = {};

  LIST_ONE_STATUS_TABS.forEach((status, index) => {
    counts[status] = queries[index].data?.data.total;
  });

  const refetch = () => queries.forEach((query) => query.refetch());

  return { counts, refetch };
}
